import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService, AuthType } from '../../services/authentication/auth.service';

@Injectable({
  providedIn: 'root'
})
export class InternalAuthGuard implements CanActivate {

  constructor(public auth: AuthService, public router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      if (this.auth.isAuthenticatedType(AuthType.Internal)) {
        return true;
      }
      this.auth.returnUrl = state.url;
      this.router.navigate(['login']);
      return false;
  }
}
